import ByteReader from "./ByteReader";
export default class ArrowVortex {
    /**
     * Parse a ArrowVortex string into a readable format.
     * @param data Copy String
     * @returns
     */
    static parse(data) {
        let is_note_data = data.indexOf('ArrowVortex:notes:') == 0;
        let is_tempo_data = data.indexOf('ArrowVortex:tempo:') == 0;
        if (!is_note_data && !is_tempo_data) {
            console.log('Argument is not AV clipboard data');
            return [];
        }
        let dwords = this.decode_dwords_from_base85(data.substring(18));
        let reader = new ByteReader(dwords);
        if (is_note_data) {
            let is_time_based = reader.readUInt8() != 0;
            return {
                type: 'notes',
                time: is_time_based,
                items: this.read_notes(reader, is_time_based)
            };
        }
        return {
            type: 'structure',
            items: this.read_structures(reader)
        };
    }
    static decode_dwords_from_base85(data) {
        data = data.replace(/z/g, '!!!!!');
        let padding = (5 - data.length % 5) % 5;
        data += "v".repeat(padding); // Padding: String.fromCharCode(0x21 + 0x55)
        let chunks = data.length / 5;
        let output = new ArrayBuffer(chunks * 4);
        let writer = new DataView(output);
        // Build dwords
        for (let chunk = 0; chunk < chunks; chunk++) {
            let dword = 0;
            for (let char = 0; char < 5; char++) {
                dword += (data.charCodeAt(chunk * 5 + char) - 0x21) * this._KEY[char];
            }
            writer.setUint32(chunk * 4, dword, false);
        }
        return output.slice(0, output.byteLength - padding);
    }
    static read_notes(reader, time = false) {
        let entries = [];
        let count = reader.readVariableInt();
        for (let i = 0; i < count; i++) {
            let first_byte = reader.readUInt8();
            let first_position = time ? reader.readDouble() : reader.readVariableInt();
            if (!(first_byte & 0x80)) {
                entries.push({
                    type: 0,
                    column: first_byte,
                    postion: first_position
                });
                continue;
            }
            let column = first_byte ^ 0x80;
            let second_position = time ? reader.readDouble() : reader.readVariableInt();
            let kind = reader.readUInt8();
            entries.push({
                type: kind,
                column: column,
                row: first_position,
                end: second_position
            });
        }
        return entries;
    }
    static read_structures(reader) {
        let entries = [];
        let count = reader.readVariableInt();
        while (count > 0) {
            let kind = reader.readUInt8();
            for (let i = 0; i < count; i++) {
                entries.push(this.read_structure(reader, kind));
            }
            count = reader.readVariableInt();
        }
        return entries;
    }
    static read_structure(reader, type) {
        let output = {
            type: type,
            position: reader.readUInt32()
        };
        switch (type) {
            case 0x00: { // BPM
                output["bpm"] = reader.readDouble();
                break;
            }
            case 0x01: { // Stop
                output["time"] = reader.readDouble();
                break;
            }
            case 0x02: { // Delay
                output["time"] = reader.readDouble();
                break;
            }
            case 0x03: { // Warp
                output["rows"] = reader.readUInt32();
                break;
            }
            case 0x04: { // TimeSignature
                output["numerator"] = reader.readUInt32();
                output["denominator"] = reader.readUInt32();
                break;
            }
            case 0x05: { // Ticks
                output["ticks"] = reader.readUInt32();
                break;
            }
            case 0x06: { // Combo
                output["combo_mul"] = reader.readUInt32();
                output["miss_mul"] = reader.readUInt32();
                break;
            }
            case 0x07: { // Speed
                output["ratio"] = reader.readDouble();
                output["delay"] = reader.readDouble();
                output["is_time"] = (reader.readUInt32() != 0);
                break;
            }
            case 0x08: { // Scroll
                output["ratio"] = reader.readDouble();
                break;
            }
            case 0x09: { // FakeSegment
                output["fake_rows"] = reader.readUInt32();
                break;
            }
            case 0x0A: { // Label
                let message_len = reader.readVariableInt();
                output["message"] = reader.readStringFixed(message_len);
                break;
            }
        }
        return output;
    }
}
// Based on: https://github.com/DeltaEpsilon7787/av-clipboard-lib
/**
 * [Math.pow(0x55, 4), Math.pow(0x55, 3), Math.pow(0x55, 2), Math.pow(0x55, 1), Math.pow(0x55, 0)]
 */
ArrowVortex._KEY = [52200625, 614125, 7225, 85, 1];
